import { useMutation, useQuery } from 'urql';
import { graphql } from '../../gql';
import { MailTemplate } from '../../gql/graphql.ts';
import { MailTemplateEditor } from './MailTemplateEditor.tsx';

interface MailSettingsPageProps {
  companyId: string;
}

const MailSettingsParticipantTemplateQuery = graphql(/* GraphQL */ `
  query mailOneDayTemplate($companyId: String!) {
    company(companyId: $companyId) {
      mailSettings {
        mailTemplateReminderOneDay {
          subject
          template
        }
      }
    }
  }
`);

const UpdateParticipantTemplateQuery = graphql(/* GraphQL */ `
  mutation updateTemplateOneDay(
    $companyId: String!
    $company: UpdateCompanyDto!
  ) {
    updateCompany(companyId: $companyId, company: $company) {
      mailSettings {
        mailTemplateReminderOneDay {
          subject
          template
        }
      }
    }
  }
`);

export const ReminderOneDayTemplateEditor: React.FC<MailSettingsPageProps> = ({
  companyId,
}) => {
  // TODO: Error handling
  const [{ data }, reExecuteQuery] = useQuery({
    query: MailSettingsParticipantTemplateQuery,
    variables: { companyId },
    pause: companyId === undefined || companyId === null,
  });

  const [, updateCompany] = useMutation(UpdateParticipantTemplateQuery);

  const onFormSubmit = (values: MailTemplate) => {
    updateCompany({
      companyId,
      company: { mailSettings: { mailTemplateReminderOneDay: values } },
    }).then(() => {
      // TODO: Check for errors and indicate success/failure to UI
      reExecuteQuery();
    });
  };

  return (
    <>
      {data?.company.mailSettings.mailTemplateReminderOneDay && (
        <MailTemplateEditor
          templateName={'Erinnerungsmail Vortag'}
          companyId={companyId}
          template={data.company.mailSettings.mailTemplateReminderOneDay}
          onSubmit={onFormSubmit}
        />
      )}
    </>
  );
};
